import { forwardRef } from 'react';
import { getIconButtonClassNames, cn } from './buttonStyles';
import { ButtonSpinner } from './ButtonSpinner';

/**
 * Botón solo icono (cuadrado). Reutiliza las variantes de `buttonStyles` (`primary`, `ghost`, `drawerActions`, etc.).
 * Incluye siempre `aria-label` descriptivo en el JSX del consumidor.
 */

export const ButtonIcon = forwardRef(
	(
		{
			children,
			className = '',
			variant = 'ghost',
			size = 'md',
			fullWidth = false,
			loading = false,
			loadingLabel = '',
			disabled = false,
			type = 'button',
			...rest
		},
		ref,
	) => {
		const rootClass = cn(getIconButtonClassNames({ variant, size, fullWidth }), className);
		const isGradient = variant === 'gradient';

		return (
			<button
				ref={ref}
				type={type}
				disabled={disabled || loading}
				className={rootClass}
				{...rest}
			>
				{isGradient ? (
					<>
						<span className="relative z-10 inline-flex items-center justify-center">
							{loading ? (
								<ButtonSpinner
									className="gap-0 [&_svg]:h-4 [&_svg]:w-4 [&_svg]:shrink-0"
									label={loadingLabel}
									labelCase="none"
								/>
							) : (
								children
							)}
						</span>
						{!loading ? (
							<div
								className="pointer-events-none absolute inset-0 bg-gradient-to-r from-purple-600 to-indigo-600 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
								aria-hidden
							/>
						) : null}
					</>
				) : loading ? (
					<ButtonSpinner
						className="gap-0 [&_svg]:h-4 [&_svg]:w-4 [&_svg]:shrink-0"
						label={loadingLabel}
						labelCase="none"
					/>
				) : (
					<span className="inline-flex items-center justify-center [&_svg]:shrink-0">{children}</span>
				)}
			</button>
		);
	},
);

ButtonIcon.displayName = 'ButtonIcon';
